import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, LOCALES, resources, type Locale } from '@gk/i18n'

const stored = (() => { try { return localStorage.getItem('gk.lang') } catch { return null } })()
const initial: Locale = (LOCALES as readonly string[]).includes(stored ?? '') ? (stored as Locale) : DEFAULT_LOCALE

void i18next.use(initReactI18next).init({
  resources, lng: initial, fallbackLng: DEFAULT_LOCALE, interpolation: { escapeValue: false }, returnNull: false,
})

export function setLanguage(l: Locale) {
  try { localStorage.setItem('gk.lang', l) } catch { /* storage blocked: the choice lasts for this session */ }
  void i18next.changeLanguage(l)
  document.documentElement.lang = l
}
/** A language for the person at a shared workstation: nothing is stored, so the next person starts from the club's own default. */
export function setLanguageTemporarily(l: Locale) { void i18next.changeLanguage(l); document.documentElement.lang = l }
export default i18next
